export default __webpack_public_path__ + "static/media/pantry1-afterC.0d473b54.jpg";